const MOBILE_MAX_WIDTH = 1024

const OPCITY_BLUE = '#0588DD'
const LIGHTER_BLUE = '#22A7FF'
export const MOBILE_BREAKPOINT = `(max-width: ${MOBILE_MAX_WIDTH}px)`
export const HEADER_BG_COLOR = OPCITY_BLUE
export const HEADER_TEXT_COLOR = OPCITY_BLUE
export const MINOR_HEADER_COLOR = LIGHTER_BLUE
